import { PageHeaderType, type LayoutSpec } from '../../../../types/LayoutConfig';
import { DEFAULT_DEALER_SPACE_DATE_RANGE_VALUE } from '../../Panels/Dealer/DealerSpaceParameters';
import { DEALER_CUSTOMER_RISK_LAYOUT_ID, DEALER_CUSTOMER_RISK_LAYOUT_TEMPLATE_ID } from '../tokens';
import { CUSTOMER_RISK_LAYOUT } from './CustomerRisk';

export const CUSTOMER_RISK_LAYOUT_SPEC: LayoutSpec = {
  templateId: DEALER_CUSTOMER_RISK_LAYOUT_TEMPLATE_ID,
  label: 'Customer Risk',
  id: DEALER_CUSTOMER_RISK_LAYOUT_ID,
  pageHeader: PageHeaderType.DealerSpaceParameters,
  dockViewLayout: CUSTOMER_RISK_LAYOUT,
  spaceParameterValues: {
    DateRange: DEFAULT_DEALER_SPACE_DATE_RANGE_VALUE,
  },
  constraints: [],
  collapsablePanels: [],
};
